import AbstractBuild from '@js/build/AbstractBuild';

export default class Build extends AbstractBuild {
}
